import * as React from "react";
import { Box } from "@mui/system";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import { Stack, TableCell, Typography } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import TableHeader from "@crema/core/AppTable/TableHeader";
import AppTableContainer from "@crema/core/AppTableContainer";
import { Button, Hidden } from "@mui/material";
import AppSearchBar from "@crema/core/AppSearchBar";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsPagination from "@crema/core/AppsPagination";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import { useDispatch, useSelector } from "react-redux";
import TableItemEmpty from "components/TableEmpty/TableItemEmpty";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import AppTooltip from "@crema/core/AppTooltip";
import AppsContainer from "@crema/core/AppsContainer";
import { getCustomDateFormat, getFileExtension } from "@crema/utility/Utils";
import AppConfirmDialog from "@crema/core/AppConfirmDialog";
import { deletePolicyManualsItem } from "redux/actions/Policies";
import { useAuthUser } from "@crema/utility/AuthHooks";
import { RoutePermittedRole } from "shared/constants/AppConst";
import AppDialog from "@crema/core/AppDialog";
import MyFileViewer from "components/FileViewer";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
        cursor: "pointer",
    },
}));
const StyledTableCell = styled(TableCell)(() => ({
    fontSize: 14,
    padding: 8,
    "&:first-of-type": {
        paddingLeft: 20,
    },
    "&:last-of-type": {
        paddingRight: 20,
    },
}));

const TableRowItem = ({ item, editButton, deleteBtnRow, user }) => {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <StyledTableRow>
                <StyledTableCell>{item.title}</StyledTableCell>
                <StyledTableCell>
                    <Typography
                        onClick={() => setOpen(true)}
                        sx={{
                            color: "blue",
                            textDecoration: "underline",
                        }}
                    >
                        {item.fileName}
                    </Typography>
                </StyledTableCell>
                <StyledTableCell>
                    {getCustomDateFormat(item.updatedOn)}
                </StyledTableCell>

                {user.role === RoutePermittedRole.ADMIN || user.role === RoutePermittedRole.SUPER_ADMIN && (
                    <StyledTableCell>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    paddingRight: "13px",
                                }}
                            >
                                <Stack direction="row" spacing={2}>
                                    <AppTooltip title="Update">
                                        <Button
                                            variant="outlined"
                                            onClick={() => editButton(item)}
                                        >
                                            <EditIcon />
                                        </Button>
                                    </AppTooltip>
                                    <AppTooltip title="Delete">
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={() =>
                                                deleteBtnRow(item.id)
                                            }
                                        >
                                            <DeleteIcon />
                                        </Button>
                                    </AppTooltip>
                                </Stack>
                            </Box>
                        </Box>
                    </StyledTableCell>
                )}
            </StyledTableRow>
            <AppDialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="lg"
                fullScreen
                title={item.fileName}
                sxStyle={{
                    m: 0,

                    "& .MuiPaper-root": {
                        m: 0,
                        height: "100%",
                        maxHeight: "100%",
                        width: "100%",
                        maxWidth: "100%",
                    },

                    "& .MuiDialogContent-root > div": {
                        maxHeight: "100%",

                        "& .simplebar-content-wrapper": {
                            overflow: "hidden !important",
                        },
                        "& .simplebar-track.simplebar-vertical": {
                            visibility: "hidden !important",
                        },
                    },
                }}
            >
                <MyFileViewer
                    type={getFileExtension(item.fileName)}
                    file={item.fileUrl}
                />
            </AppDialog>
        </>
    );
};

TableRowItem.propTypes = {
    editButton: PropTypes.func.isRequired,
    deleteBtnRow: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};
export default function AddPolicyDetails({ setOpen, setAction, setEditRow }) {
    const { user } = useAuthUser();
    const loading = useSelector((state) => state.common.loading);
    const [deleteConfirmBox, setDeleteConfirmBox] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchs, setSearch] = React.useState("");
    const [filteredList, setFilteredList] = React.useState([]);
    const dispatch = useDispatch();

    const policyItem = useSelector((state) => state.policyReducer.policyItem);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const deleteBtnRow = (id) => {
        setDeleteId(id);
        setDeleteConfirmBox(true);
    };
    const onDeleteConfirm = () => {
        dispatch(deletePolicyManualsItem(deleteId)).then((res) => {
            if (res.httpStatus === "OK") {
                setDeleteConfirmBox(false);
            }
        });
    };
    const editButton = (item) => {
        setEditRow(item);
        setOpen(true);
        setAction({
            add: false,
            edit: true,
        });
    };
    React.useEffect(() => {
        setFilteredList(policyItem);
    }, [policyItem]);
    React.useEffect(() => {
        if (searchs.length < 1) {
            setFilteredList(policyItem);
        } else {
            const filteredItems = policyItem?.filter((item) => {
                return Object.keys(item).some((key) => {
                    if (Array.isArray(item[key])) {
                        return item[key].some((el) => {
                            return el.deptName
                                .toLowerCase()
                                .includes(searchs.toLowerCase());
                        });
                    } else {
                        return String(item[key])
                            .toLowerCase()
                            .includes(String(searchs.toLowerCase()));
                    }
                });
            });
            setPage(0);
            setFilteredList(filteredItems);
        }
    }, [searchs]);
    return (
        <Box>
            <AppsContainer fullView>
                <AppsHeader>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: 1,
                        }}
                    >
                        <AppSearchBar
                            iconPosition="left"
                            overlap={false}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={"Search here..."}
                        />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                ml: "auto",
                            }}
                        >
                            <Hidden smDown>
                                <AppsPagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={filteredList?.length || 0}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={
                                        handleChangeRowsPerPage
                                    }
                                />
                            </Hidden>
                        </Box>
                    </Box>
                </AppsHeader>
                <AppsContent
                    sx={{
                        paddingTop: 2.5,
                        paddingBottom: 2.5,
                    }}
                >
                    <AppConfirmDialog
                        open={deleteConfirmBox}
                        onDeny={setDeleteConfirmBox}
                        onConfirm={() => onDeleteConfirm()}
                        title={" Do you really want to delete ?"}
                        dialogTitle={"Delete"}
                    />
                    <AppTableContainer>
                        <Table stickyHeader className="table">
                            <TableHead>
                                <TableHeader>
                                    <TableCell>Title</TableCell>
                                    <TableCell>File</TableCell>
                                    <TableCell>Date</TableCell>
                                    {user.role === RoutePermittedRole.ADMIN || user.role === RoutePermittedRole.SUPER_ADMIN && (
                                        <TableCell>Action</TableCell>
                                    )}
                                </TableHeader>
                            </TableHead>
                            <TableBody>
                                {filteredList?.length > 0 ? (
                                    filteredList?.length > 0 &&
                                    filteredList
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        .map((item) => {
                                            return (
                                                <TableRowItem
                                                    key={item.id}
                                                    item={item}
                                                    user={user}
                                                    editButton={editButton}
                                                    deleteBtnRow={deleteBtnRow}
                                                />
                                            );
                                        })
                                ) : (
                                    <TableItemEmpty
                                        text={
                                            loading
                                                ? "Loading..."
                                                : "No record found..."
                                        }
                                    />
                                )}
                            </TableBody>
                        </Table>
                    </AppTableContainer>
                </AppsContent>
                <Hidden smUp>
                    <AppsPagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={filteredList?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Hidden>
            </AppsContainer>
        </Box>
    );
}
AddPolicyDetails.propTypes = {
    setOpen: PropTypes.func.isRequired,
    setAction: PropTypes.func.isRequired,
    setEditRow: PropTypes.func.isRequired,
};
